import { Support } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";

export const SupportService = {
  getSupportService: async ({ queryParams }) => {
    try {
      const payload = {
        ...Support.getSupport,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  replySupportService: async ({ id, bodyData }) => {
    try {
      const payload = {
        ...Support.reply(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
